import React, {useState,useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {
	deleteScheduledMessage,
	selectUpcomingMessages,
	getScheduledMessages,
	selectPastMessages,
	editMessage,
	hideEditor
} from './messengerSlice'
import {selectAllClientContacts} from '../MessageCenter/messageCenterSlice'
import Moment from 'react-moment'
import { selectAllTags } from '../../state/accountTagsSlice'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import MessageCreator from '../MessageCreator/MessageCreator'
import MessageEditor from '../MessageEditor/MessageEditor'
import { isFulfilled } from '@reduxjs/toolkit'
import {capitalize} from '../../util/util'
import {useGymTrainers} from '../users/hooks'

const dateOptions = { 
	year: 'numeric',
	month: 'short',
	day: 'numeric',
	hour:'2-digit',
	minute:'2-digit'
}

const ScheduledMessage = props =>{
	const dispatch = useDispatch()
	const messageInEditor = useSelector(state=>state.messenger.editor.messageId)
	const {message,send_at,schedule:{start,end,freq,interval,week_days,is_recurring},recipients,id,sent,attachment,media_type_id} = props.message
	const isRange = start !== end && !is_recurring
	return (
		<tr className="bg-white">
			<td>
				<div className="d-flex">
					<div className="d-flex flex-column justify-content-between" style={{flex:'1 1 auto'}}>
						{Boolean(attachment)&&
							<div>
								{media_type_id === 2 ?
									<img 
										style={{
											maxWidth:'100px',
											maxHeight:'100px',
											objectFit:'cover',
											flex:'0 0 auto',
											borderRadius:'4px',
										}} 
										src={attachment}
									/>
									:
									<video
										controls 
										style={{
											maxWidth:'100px',
											maxHeight:'100px',
											objectFit:'cover',
											flex:'0 0 auto',
											borderRadius:'4px',
										}} 
										src={attachment}
									/>
								}
							</div>
						}
						<div style={{fontSize:'14px',whiteSpace:'pre-wrap'}}>{message}</div>
						<small className="text-primary">
							{(isRange||Boolean(is_recurring))&&'From: '}
							{new Date(start.split(' ').join('T')).toLocaleString([],dateOptions)}
						</small>
						{isRange&&
							<small className="text-primary">
								Until: {new Date(end.split(' ').join('T')).toLocaleString([],dateOptions)}
							</small>
						}
						{(Boolean(is_recurring)||isRange)&&
							<small className="text-primary">
								Every {
									freq==='weekly'
									?week_days.filter(s=>Boolean(s)).map(capitalize).join(', ')
									:`${interval} day${interval>1?'s':''}`}
							</small>
						}
						<small>
							{recipients?.length} recipients
						</small>
					</div>
					{
						!Boolean(props.isPast)?
						<div className="d-flex flex-column" style={{flex:'0 0 auto'}}>
							<Button 
								onClick={()=>props.onEdit(id)}
								size="sm" 
								variant="outline-secondary" 
								className="mb-2 mr-0">
								<i className="fas fa-edit"/>
							</Button>
							<Button 
								onClick={()=>{
									if(window.confirm('Are you sure?')){
										//if current message in editor is the one being deleted
										//close the editor and reset editor state
										if(messageInEditor == id){
											dispatch(hideEditor())
										}
										dispatch(deleteScheduledMessage(id))
									}
								}}
								size="sm" 
								variant="outline-danger">
								<i className="fas fa-trash"/>
							</Button>
						</div>
						:
						(
							isRange ?
							<Badge variant="info" className="align-self-start">
								Ended
							</Badge>
							:
							<Badge variant={sent===1?'success':'danger'} className="align-self-start">
								{sent===1?'Sent':'Not Sent'}
							</Badge>
						)
					}
				</div>
			</td>
		</tr>
	)
}

const GroupMessenger = props =>{
	const dispatch = useDispatch()
	const upcomingMessages = useSelector(selectUpcomingMessages)
	const pastMessages = useSelector(selectPastMessages)
	const clients = useSelector(selectAllClientContacts) || []
	const {trainers} = useGymTrainers()
	const tags = useSelector(selectAllTags)
	const showEditor = useSelector(state=>state.messenger.editor.show)

	const [showSuccess, setShowSuccess] = useState(false)

	/* ---- load more past messages state ----- */
	//load 20 at a time
	const blockSize = 10
	const [numPastMessages,setNumPastMessages] = useState(blockSize)
	const handleViewMorePastMessages = ()=>{
		setNumPastMessages(numPastMessages+blockSize)
	}

	useEffect(()=>{
		dispatch(getScheduledMessages())
	},[])
	const [tabKey, setTabKey] = useState('create')
	const editHandler = (messageId)=>{
		setTabKey('edit')
		dispatch(editMessage(messageId))
	}
	const closeEditorHandler = (e, edit) => {
		e.stopPropagation()
		//hide editor
		dispatch(hideEditor())
		if(edit){
			setShowSuccess(true)
			setTimeout(function(){setShowSuccess(false)}, 3000);
			console.log('successfully edited!')
		}
		//go to scheduled messages tab if closing the editor tab while it is active
		if (tabKey === 'edit') setTabKey('scheduled')
	}
	return (
		<div className="p-3 px-md-5 position-relative" style={{flex:'1 1 auto',overflow:'auto',maxWidth:'960px',margin:'0 auto'}}>
			<div>
				<i className="fa fa-info-circle mr-1"/>
				Here you can "broadcast" or schedule a message to many <em>different</em> clients at once.
			</div>
			<Tabs activeKey={tabKey} onSelect={(k) => setTabKey(k)}>
				<Tab eventKey="create" title="Create" className="pt-2">
					<strong>New Message</strong>
					<MessageCreator 
						tags={tags} 
						clients={clients}
						trainers={trainers}
					/>
				</Tab>
				<Tab eventKey="scheduled" title="Scheduled">
					<strong className="my-2 d-block">Upcoming messages</strong>
					{showSuccess && <p style={{color:'green'}}>Message Edited</p>}
					<Table bordered hover>
						<tbody>
							{
								upcomingMessages.length?
								upcomingMessages.map( message => <ScheduledMessage onEdit={editHandler} message={message} /> ):
								"No upcoming messages"
							}
						</tbody>
					</Table>
					<strong className="my-2 d-block">Previous messages</strong>
					<Table bordered hover>
						<tbody>
							{
								pastMessages.length?
								pastMessages
									.slice(0,numPastMessages)
									.map( message => (
										<ScheduledMessage 
											onEdit={editHandler} 
											message={message} 
											isPast={true}
										/>
									))
								:
								"No past messages"
							}
						</tbody>
					</Table>
					{numPastMessages<pastMessages.length&&
						<Button 
							onClick={handleViewMorePastMessages} 
							variant="outline-primary"
							block
						>
							View More
						</Button>
					}
				</Tab>

				{showEditor &&
					<Tab 
						eventKey="edit" 
						title={
							<span className="d-flex align-items-start">
								<span className="pl-3 pr-2">Edit</span>
								<button 
									onClick={closeEditorHandler}
									className="fa fa-times" 
									style={{
										background:'transparent',
										border:'none',
										padding:'4px',
										fontSize:'10px'
									}}/>
							</span>
						}//end tab.title
						className="pt-2">
						<strong>Edit Message</strong>
						<MessageEditor 
							onCancel={closeEditorHandler} 
							tags={tags} 
							clients={clients}
							trainers={trainers}
						/>
					</Tab>
				}
			</Tabs>
		</div>
	)
}

export default GroupMessenger